import { render } from "./ReloadingPage.vue?vue&type=template&id=53584386&ts=true"
import script from "./ReloadingPage.vue?vue&type=script&lang=ts"
export * from "./ReloadingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__